/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Inactive

1 = Pending

2 = Active

3 = Disabled


 */
export type ActivationStatus =
  (typeof ActivationStatus)[keyof typeof ActivationStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActivationStatus = {
  NotSent: 0,
  Pending: 1,
  Active: 2,
  Disabled: 3,
} as const;
